import React from 'react';

const CTA = () => {
    return (
        <section id="cta" className="wrapper style3">
            <div className="container">
                <header>
                    <h2>Está em dúvida? Entre em contato!</h2>
                    <a
                        href="https://wa.me/5541987767716?text=Quero%20um%20produto%20%C3%BAnico"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="button"
                    >
                        <i className="fab fa-whatsapp"></i> Falar pelo WhatsApp
                    </a>
                </header>
            </div>
        </section>
    );
};

export default CTA;
